document.addEventListener('DOMContentLoaded', function() {
    let uspInterval: number | undefined;
    let resizeTimeout: number | undefined;
    let lastWindowWidth = window.innerWidth;

    if (window.innerWidth <= 941) {
        selectRandomUSP();
        startUSPInterval();
    }

    window.addEventListener('resize', function() {
        if (resizeTimeout) {
            clearTimeout(resizeTimeout);
        }
        resizeTimeout = window.setTimeout(function() {
            const currentWindowWidth = window.innerWidth;

            if ((lastWindowWidth > 941 && currentWindowWidth <= 941) || (lastWindowWidth <= 941 && currentWindowWidth > 941)) {
                if (currentWindowWidth > 941) {
                    showAllUSPs();
                    stopUSPInterval(); 
                } else {
                    selectRandomUSP();
                    startUSPInterval(); 
                }
            }
            lastWindowWidth = currentWindowWidth;
        }, 200);
    });

    function selectRandomUSP() {
        const usps = Array.from(document.querySelectorAll('.header-usps ul li')) as HTMLElement[];
        if (usps.length > 0) {
            const randomIndex = Math.floor(Math.random() * usps.length);
            usps.forEach((usp, index) => {
                usp.style.display = index === randomIndex ? 'flex' : 'none';
            });
        }
    }

    function showAllUSPs() {
        const usps = Array.from(document.querySelectorAll('.header-usps ul li')) as HTMLElement[];
        usps.forEach(usp => usp.style.display = 'flex');
    }

    function startUSPInterval() {
        if (uspInterval) {
            clearInterval(uspInterval);
        }
        uspInterval = window.setInterval(() => {
            selectRandomUSP();
        }, 5000);
    }

    function stopUSPInterval() {
        if (uspInterval) {
            clearInterval(uspInterval);
            uspInterval = undefined;
        }
    }

    // Anchor scrolling with header offset
    function getHeaderHeight(): number {
        const header = document.querySelector('header');
        if (!header) return 0;
        return header.offsetHeight;
    }

    function scrollToAnchor(anchorId: string, extraOffset: number = 20): void {
        const element = document.getElementById(anchorId);
        if (!element) return;

        const headerHeight = getHeaderHeight();
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerHeight - extraOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }

    // Handle anchor link clicks
    document.addEventListener('click', function(e: Event) {
        const target = e.target as HTMLElement;
        const anchor = target.closest('a[href^="#"]') as HTMLAnchorElement;
        
        if (!anchor) return;

        const href = anchor.getAttribute('href');
        if (!href || href === '#') return;

        const anchorId = href.substring(1);
        const targetElement = document.getElementById(anchorId);
        
        if (targetElement) {
            e.preventDefault();
            scrollToAnchor(anchorId);
        }
    });

    // Handle hash in URL on page load
    function handleHashOnLoad(): void {
        if (window.location.hash) {
            const anchorId = window.location.hash.substring(1);
            // Small delay to ensure page is fully rendered
            setTimeout(() => {
                scrollToAnchor(anchorId);
            }, 100);
        }
    }

    // Handle hash changes (e.g., when navigating with browser back/forward)
    window.addEventListener('hashchange', function() {
        if (window.location.hash) {
            const anchorId = window.location.hash.substring(1);
            scrollToAnchor(anchorId);
        }
    });

    // Initial hash handling
    handleHashOnLoad();
});
